import { useState, useContext } from 'react'
import { Box, Divider, IconButton, Paper, Popper, Stack, Typography, Button } from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import CloseIcon from "@mui/icons-material/Close";
import { AuthContext } from '../../../contexts/auth/authContext'
import { savePromptAnswer } from '../../../services/api-query/customer'
import { DataContext } from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain, analyticsCta } from '../../../services/constants'
import { sendClickAnalytics, sendViewAnalytics } from '../../common/util/util'

export default function PromptBanner() {
    const border = custom.border
    const auth = useContext(AuthContext)
    const { dashboard } = useContext(DataContext)
    const hotwater = dashboard?.hotwater
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [show, setShow] = useState(true);

    function handlePromptClick(event: any) {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        sendViewAnalytics('/rightPanel', {
                domain: analyticsDomain.hotWater,
                name: analyticsPage.hotWaterControlReminder
            })
      }
    
    function handlePromptRemind() {
        savePromptAnswer(false)
        setAnchorEl(null)
        setShow(false)
        sendClickAnalytics('/rightPanel', {
              domain: analyticsDomain.hotWater,
              name: analyticsCta.hotWaterControlReminderLater,
              metadata: {},
            })
    }

    function handlePromptDismiss() {
        savePromptAnswer(true)
        setAnchorEl(null)
        setShow(false)
        sendClickAnalytics('/rightPanel', {
              domain: analyticsDomain.hotWater,
              name: analyticsCta.hotWaterControlReminderHide,
              metadata: {},
            })
    }

    return (
        <>
        {show && (
            <Box p={custom.spacing.xxs} 
                sx={{ backgroundColor: 'sz.colors.surfaceAccent' }}
                onClick={handlePromptClick}>
                <Stack direction="row" 
                    spacing={custom.spacing.xxs}>
                    <Box
                        component={'img'}
                        loading="lazy"
                        alt="Pause Icon"
                        src="/images/ToggleRightIcon.svg"
                    />
                    <Typography variant="szBody.Regular.Small" 
                        id="hotwaterTroubleshootingReminderNote"
                        pt={custom.spacing.xxxxs}>
                        {hotwater?.troubleshooting?.reminder?.note}
                    </Typography>
                    <ArrowForwardIosIcon
                        sx={{
                            marginLeft: 'auto',
                            pt: custom.spacing.xxxs,
                            mr: custom.spacing.xxs,
                            height: '1rem',
                        }}
                    />
                </Stack>
            </Box>
        )}
        <Popper id={"promptHotwater"} 
                open={Boolean(anchorEl)} 
                anchorEl={anchorEl}  >
            <Paper sx={{ 
                    borderRadius: custom.corners4, 
                }} elevation={10}
                id="hotwaterReminderCheckControlPopup">
                <Box width="330px" 
                            px={custom.spacing.sm}
                            pt={custom.spacing.xxxs}
                            pb={custom.spacing.sm}
                            >
                    <Stack alignItems="center" 
                            direction="row" 
                            display="flex" 
                            width="100%"
                            >
                        <Typography component={"h3"} 
                            variant="szHeading.Bold.Small">
                                Check hot water control
                        </Typography>
                        <IconButton id="closePopup" 
                            onClick={()=>setAnchorEl(null)} 
                            sx={{ ml: 'auto',  }}>
                            <CloseIcon sx={{ 
                                    width: '20px', 
                                    height: '20px',
                                    p: custom.spacing.xxs,  
                                    border, 
                                    borderRadius: custom.corners3, 
                                    background: '#FFF' }} />
                        </IconButton>
                    </Stack>
                    <Divider />
                    <Box display={"flex"} 
                        justifyContent={"center"} 
                        width="100%">
                        <Box
                            p={custom.spacing.sm}
                            component={'img'}
                            loading="lazy"
                            height={"145px"}
                            width={"50px"}
                            alt="Pause Icon"
                            src="/images/Illustration.svg"
                        />
                    </Box>
                    <Box p={custom.spacing.xxs}>
                        <Typography variant="szBody.Regular.Medium"
                            id="hotwaterTroubleshootingReminderDescription">
                            {hotwater?.troubleshooting?.reminder?.description}
                        </Typography>
                    </Box>    
                    <Box p={custom.spacing.xxs} >
                        <Button variant="text" 
                                color="primary" 
                                id="remindLaterButton"
                                onClick={auth?.staff?()=>{}:handlePromptRemind}>
                            <Typography variant="szBody.Regular.Small" 
                                color={auth?.staff?"lightgrey":"primary"} 
                                sx={{ 
                                    float: "left", 
                                    // py: custom.spacing.sm,
                                    px: custom.spacing.xxs
                                }}>
                            {hotwater?.troubleshooting?.reminder?.deferAction?.title}
                            </Typography>
                        </Button>
                        <Button variant="contained" 
                                color="primary" 
                                id="acklnowledgeButton"
                            onClick={auth?.staff?()=>{}:handlePromptDismiss}
                            sx={{ 
                                float: "right", 
                                py: custom.spacing.sm,
                                px: custom.spacing.sm
                            }}>
                            <Typography variant="szBody.Regular.Small"
                                    color={auth?.staff?"lightgrey":"#FFF"}>
                                {hotwater?.troubleshooting?.reminder?.acknowledgementAction?.title}
                            </Typography> 
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Popper>
     </>
    )
}

